<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/news'"
            >News & Updates</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="
        display: flex;
        justify-content: space-between;
        margin-top: 60px;
        padding: 0 20px;
      "
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-4" style="display: flex">
        <div class="col-9">
          <date-range-picker
            ref="picker"
            :locale-data="{
              firstDay: 1,
              format: 'dd-mm-yyyy',
              applyLabel: 'Apply',
              cancelLabel: 'Cancel',
            }"
            :timePicker="false"
            :showDropdowns="true"
            :autoApply="true"
            v-model="dateRange"
            @update="filter()"
            :linkedCalendars="true"
            style="width: 100%"
          >
          </date-range-picker>
        </div>
        <div class="col-3" style="padding: 0">
          <button
            style="font-size: 14px"
            type="button"
            class="btn btn-info"
            @click="clearDateRage()"
          >
            Clear
          </button>
        </div>
      </span>
      <!-- <span class="col-3">
        <select
          class="custom-select"
          v-model="type"
          @change="filter()"
          :showClearButton="true"
        >
          <option v-if="!type" :value="null" disabled selected>
            Select a News Type
          </option>
          <option v-else :value="null" selected>Clear Selection</option>
          <option v-for="type in newsTypes" :key="type.name" :value="type.id">
            {{ type.name }}
          </option>
        </select>
      </span> -->
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          width: 200px;
          background-color: transparent;
          margin-right: 40px;
          border-radius: 0px;
        "
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 10px;
            height: 100px;
            cursor: pointer;
          "
          @click="toggleCreateNewsModal()"
        >
          <div
            style="
              min-width: 100%;
              padding: 5px;
              margin: 0;
              flex-direction: row;
              justify-content: space-between;
              display: flex;
              align-items: center;
              color: #8cc63f;
            "
          >
            <i style="font-size: 40px" class="fa fa-edit"></i>
            <p style="margin-top: 10px; font-size: 13px; font-weight: bold">
              Add New Update
            </p>
          </div>
        </div>
      </md-card>
      <md-card
        class="md-card-stats"
        style="width: 200px; background-color: transparent; border-radius: 0px"
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            padding: 10px;
            height: 100px;
          "
        >
          <div
            style="
              min-width: 100%;
              padding: 5px;
              margin: 0;
              flex-direction: row;
              justify-content: space-between;
              display: flex;
              align-items: center;
              color: #8cc63f;
            "
          >
            <i style="font-size: 40px" class="fa fa-edit"></i>
            <p style="margin-top: 10px; font-size: 13px; font-weight: bold">
              Create New Report
            </p>
          </div>
        </div>
      </md-card>
    </div>
    <div
      class="col-3"
      style="margin-top: 30px; display: flex; justify-content: center"
    >
      <h5 style="font-weight: bold; font-size: 18px; color: black">
        NEWS & UPDATES
      </h5>
    </div>
    <div style="display: flex; justify-content: center">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 10px 40px;
          margin-top: 10px;
        "
      >
        <spinner v-if="searchingNews" />
        <vue-good-table
          v-else
          :rows="newsList"
          :columns="newsColumns"
          max-height="450px"
        >
          <template slot="table-row" slot-scope="props">
            <!-- <span class="truncate-text" v-if="props.column.label == 'Update'">
              {{ truncate(props.row.content) }}
            </span> -->
            <span v-if="props.column.label == 'Actions'">
              <i
                style="cursor: pointer; color: #8cc63f"
                @click="toggleUpdateNewsModal(props.row)"
                class="fa fa-edit"
              ></i>
              <i
                style="cursor: pointer; color: #dc3545"
                @click="deleteNews(props.row.id)"
                class="fa fa-trash"
              ></i>
            </span>
          </template>
        </vue-good-table>
        <!-- <table v-else>
          <thead>
            <tr>
              <th>Update</th>
              <th>Status</th>
              <th>Category</th>
              <th>Tags</th>
              <th>Date</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(news, key) in newsList" :key="key">
              <td class="col-7" style="padding: 0">
                {{ news.content }}
              </td>
              <td>
                {{
                  statusList.find((status) => {
                    return status.id == news.status;
                  }).name
                }}
              </td>
              <td>
                {{
                  categories.find((status) => {
                    return status.id == news.category;
                  }).name
                }}
              </td>
              <td>
                {{ news.tags }}
              </td>
              <td>
                {{ moment(news.date).format("YYYY-MM-DD") }}
              </td>
              <td>
                <i
                  style="cursor: pointer"
                  @click="toggleUpdateNewsModal(news)"
                  class="fa fa-edit"
                ></i>
              </td>
              <td>
                <i
                  style="cursor: pointer"
                  @click="deleteNews(news.id)"
                  class="fa fa-trash"
                ></i>
              </td>
            </tr>
          </tbody>
        </table> -->
      </md-card>
    </div>
    <news-modal
      :active="showNewsModal"
      :actionType="actionModalType"
      :activeNews="activeNews"
      @saveRequest="handleSave"
      @closeRequest="
        actionModalType == 'createModal'
          ? toggleCreateNewsModal()
          : toggleUpdateNewsModal()
      "
    />
  </div>
</template>
<script>
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import moment from "moment";
import NewsFilter from "../../filters/NewsFilter";
import DateRangePicker from "vue2-daterange-picker";
import Spinner from "vue-simple-spinner";
import NewsModal from "./components/modals/newsModal.vue";

export default {
  name: "news",
  data() {
    return {
      activeNews: null,
      actionModalType: null,
      category: null,
      news_id: null,
      dateRange: {
        startDate: null,
        endDate: null,
      },
      showNewsModal: false,
      categories: [
        { id: "agriculture", name: "Agriculture" },
        { id: "commodities", name: "Commodities" },
        { id: "crypto", name: "Crypto" },
        { id: "stocks_etfs", name: "Stocks & ETFs" },
        { id: "yurbe", name: "YurBE" },
      ],
      statusList: [
        { id: "draft", name: "Draft" },
        { id: "private", name: "Private" },
        { id: "published", name: "Published" },
      ],
      newsColumns: [
        {
          label: "Update",
          field: "content",
        },
        {
          label: "Status",
          field: this.getStatus,
        },
        {
          label: "Category",
          field: this.getCategory,
        },
        {
          label: "Tags",
          field: "tags",
        },
        {
          label: "Date",
          field: "date",
        },
        {
          label: "Actions",
          field: "action",
          tdClass: "newsActionsColumn",
        },
      ],
    };
  },
  components: {
    DateRangePicker,
    Spinner,
    NewsModal,
  },
  created: function () {
    var newsFilter = NewsFilter();
    this.$store.dispatch("searchNews", {
      filter: newsFilter,
      resultMode: "default",
    });
  },

  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      newsList: (state) => state.newsStore.newsSearch.news,
      createNewsStatus: (state) => state.newsStore.newsCreate.createNewsStatus,
      updateNewsStatus: (state) => state.newsStore.newsUpdate.updateNewsStatus,
      deleteNewsStatus: (state) => state.newsStore.newsDelete.deleteNewsStatus,
      searchingNews: (state) => state.newsStore.newsSearch.searchingnews,
    }),
    moment() {
      return moment;
    },
  },
  methods: {
    init() {
      this.selectedNewsId = null;
      this.actionModalType = null;
      this.showNewsModal = false;
      this.activeNews = null;
      this.$store.dispatch("searchNews");
    },
    getStatus(news) {
      return this.statusList.find((status) => {
        return status.id == news.status;
      }).name;
    },
    getCategory(news) {
      return this.categories.find((status) => {
        return status.id == news.category;
      }).name;
    },

    truncate(content) {
      // if (content.length > 10) {
      //   return content.slice(0, 60) + "...";
      // }
      return content;
    },
    // redirectToCreateNews() {
    //   this.$router.push("/" + this.authUser.userable_type + "/news/create");
    // },
    // redirectToUpdateNews(news) {
    //   this.$router.push(
    //     "/" + this.authUser.userable_type + "/news/" + "/update/" + news.id
    //   );
    // },
    toggleCreateNewsModal() {
      this.showNewsModal = !this.showNewsModal;
      this.showNewsModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdateNewsModal(activeNews) {
      this.showNewsModal = !this.showNewsModal;
      if (this.showNewsModal) {
        this.actionModalType = "updateModal";
        this.activeNews = activeNews;
      } else {
        this.actionModalType = null;
        this.activeNews = null;
      }
    },
    filter() {
      var newsFilter = NewsFilter();
      if (this.category) {
        newsFilter.categories = [this.category];
      }
      if (this.dateRange.startDate != null && this.dateRange.endDate != null) {
        let start_date = moment(this.dateRange.startDate).format("YYYY-MM-DD");
        let end_date = moment(this.dateRange.endDate).format("YYYY-MM-DD");
        let date_range = { startDate: start_date, endDate: end_date };
        newsFilter.dateRange = date_range;
      }
      this.$store.dispatch("searchNews", {
        filter: newsFilter,
        resultMode: "default",
      });
    },
    clearDateRage() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.filter();
    },
    deleteNews(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this news?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("deleteNews", id);
        }
      });
    },
    formValidation(storeNews) {
      const result = { isValid: true, message: "" };
      result.message += "Please fill all required fields";
      let missingFieldsString = "";

      if (!storeNews.content) {
        missingFieldsString += "News content is empty, ";
        result.isValid = false;
      }
      if (!storeNews.date) {
        missingFieldsString += "News date is missing, ";
        result.isValid = false;
      }
      if (!storeNews.category) {
        missingFieldsString += "News category is missing, ";
        result.isValid = false;
      }
      if (!storeNews.tags) {
        missingFieldsString += "News tags is missing, ";
        result.isValid = false;
      }
      if (!storeNews.status) {
        missingFieldsString += "News status is missing, ";
        result.isValid = false;
      }

      if (missingFieldsString.length > 0) {
        // remove trailing comma
        missingFieldsString = missingFieldsString.substring(
          0,
          missingFieldsString.length - 2
        );
        result.message += ` (${missingFieldsString})`;
      }
      return result;
    },
    handleSave(storeNews) {
      const { isValid, message } = this.formValidation(storeNews);
      if (!isValid) {
        sweetAlert({
          title: "Error",
          text: message,
          type: "error",
          confirmButtonText: "Return",
        });
        return;
      }
      if (this.actionModalType == "createModal") {
        this.createNews(storeNews);
      } else {
        this.updateNews(storeNews);
      }
    },
    createNews(storeNews) {
      this.$store.dispatch("createNews", storeNews);
    },
    updateNews(storeNews) {
      this.$store.dispatch("updateNews", storeNews);
    },
  },
  watch: {
    createNewsStatus() {
      if (this.createNewsStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "News has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createNewsStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "News creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateNewsStatus() {
      if (this.updateNewsStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "News has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateNewsStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "News update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteNewsStatus() {
      if (this.deleteNewsStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "News has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteNewsStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "News delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script> 
 <style>
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.custom-select {
  background-color: #fafaf7;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
  background-color: rgb(250, 250, 247) !important;
}
.truncate-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
}

.vgt-table.bordered td,
.vgt-table.bordered th {
  border: hidden !important;
  background: none;
}

.vgt-inner-wrap {
  box-shadow: none !important;
}
.vgt-left-align {
  text-align: left;
}
.vgt-right-align {
  text-align: left;
}
.vgt-table.bordered td,
.vgt-table.bordered th {
  background: #fff;
}

table.vgt-table thead th {
  position: -webkit-sticky; /* for Safari */
  position: sticky;
  top: 0;
}

/* ===== Scrollbar CSS ===== */
/* Firefox */
* {
  scrollbar-width: auto;
  scrollbar-color: #dbd5dc #ffffff;
}

/* Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 12px;
}

*::-webkit-scrollbar-track {
  background: #ffffff;
}

*::-webkit-scrollbar-thumb {
  background-color: #dbd5dc;
  border-radius: 10px;
  border: 3px solid #ffffff;
}

.newsActionsColumn {
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/news.vue